import {post, get} from './Tools';

const processPoliza = async (definicion_poliza_id, periodo_id, anio, num_periodo) => {
  const payload = {
    definicion_poliza_id,
    periodo_id,
    anio,
    num_periodo
  };
  const response = await post(`${process.env.REACT_APP_SERVER}poliza_contable/process`, payload);
  return response;
};

const getPoliza = async (definicion_poliza_id, periodo_id, anio, num_periodo) => {
  const response = await get(`${process.env.REACT_APP_SERVER}poliza_contable/${definicion_poliza_id}/${periodo_id}/${anio}/${num_periodo}`);
  return response;
};

const sendToOdooPoliza = async (poliza_id) => {
  const response = await post(`${process.env.REACT_APP_SERVER}poliza_contable/send-to-odoo`, {poliza_id});
  return response;
};


export { processPoliza, getPoliza, sendToOdooPoliza};
